export default "__VITE_PUBLIC_ASSET__ee89d20d__"